import { render, staticRenderFns } from "./AddElement.vue?vue&type=template&id=1741ecf6&scoped=true&"
import script from "./AddElement.vue?vue&type=script&lang=js&"
export * from "./AddElement.vue?vue&type=script&lang=js&"
import style0 from "./AddElement.vue?vue&type=style&index=0&id=1741ecf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1741ecf6",
  null
  
)

export default component.exports